export default {
  // 해당 프레임워크가 사용될 시스템 이름
  // 특정 타입 템플릿에서 상단에 출력됨
  name: "UI Framework",

  // 개발하고 있는 서비스의 고유 ID 값
  // request 해더 및 Log 생성 시, 사용 된다.
  systemId: "SCM",

  // request 해더에 사용되는 API 버전 기본 정보
  // api 조회 간 meta 값에 apiVersion 정보가 있을 경우, meta값을 우선으로 한다.
  apiVersion: "2.0.0",

  // 서버 (개발, 운영) 환경에 build하여 업로드 할 경우, 기본 api base url
  buildUrl: "/",

  // 회사코드
  companyName: "㈜화영SCMS",
  companyCode: "WY",
};
